import { orderStatusActionTypes } from './order-status-action-types';
import { authorizedRequest } from '../../common/request';


export const requestOrderStatusData = (dispatch) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/orderstatuses`)
		.then(element => {
            dispatch({
                type: orderStatusActionTypes.ORDER_STATUS_RECEIVED,
                data: element
            });
        })
        // eslint-disable-next-line no-console
		.catch(error => console.log("Error fetching order status: " + error));
};



// WEBPACK FOOTER //
// ./src/orderStatus/reducers/order-status-actions.js